import { useState, useEffect } from 'react';

export default function PopupModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [dontShow, setDontShow] = useState(false);

  useEffect(() => {
    const closedDate = localStorage.getItem('popup_closed_date');
    const today = new Date().toISOString().split('T')[0];
    if (closedDate !== today) {
      const timer = setTimeout(() => setIsOpen(true), 600);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleClose = () => {
    if (dontShow) {
      const today = new Date().toISOString().split('T')[0];
      localStorage.setItem('popup_closed_date', today);
    }
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-3 md:p-6 animate-fade-in"
      onClick={handleClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="relative w-full max-w-[540px] animate-fade-in-up"
        onClick={(e) => e.stopPropagation()}
      >
        {/* 팝업 이미지 */}
        <img
          src="https://public.readdy.ai/ai/img_res/edited_dfb5f83ef7b83ecf909f8d76b23fbc2c_816a3c4a.jpg"
          alt="신상도역 iaan 아파트 - 선착순 4천만원 상당 무상혜택"
          className="w-full h-auto rounded-t-xl"
        />

        {/* 하단 액션 */}
        <div className="bg-foreground-950 rounded-b-xl px-5 py-4 flex flex-row items-center justify-between gap-3">
          <label className="flex items-center gap-2.5 cursor-pointer select-none">
            <input
              type="checkbox"
              checked={dontShow}
              onChange={(e) => setDontShow(e.target.checked)}
              className="w-4 h-4 md:w-5 md:h-5 rounded border-background-600 accent-primary-500 cursor-pointer"
            />
            <span className="text-xs md:text-sm text-background-50">
              오늘 하루 안보기
            </span>
          </label>
          <button
            type="button"
            onClick={handleClose}
            className="px-5 py-2 md:px-8 md:py-2.5 bg-primary-500 text-background-50 rounded-lg text-xs md:text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
}